export default {
  // Form Labels
  address: "Address:",
  blockchain: "Blockchain:",
  currency: "Currency:",
  monitorCondition: "Monitor Condition:",
  monitorDirection: "Monitor Direction:",
  monitorName: "Monitor Name:",
  relatedCase: "Related Case:",
  remark: "Remark:",
  monitorType: "Monitor Type:",
  pushChannel: "Push Channel:",

  // Placeholders
  inputAddress: "Please enter address",
  selectBlockchain: "Please select blockchain",
  inputCurrency: "Please enter currency",
  minAmount: "Min Amount",
  maxAmount: "Max Amount",
  inputMonitorName: "Please enter monitor name",
  selectRelatedCase: "Please select related case",
  inputRemark: "Please enter remark content",
  pleaseSelect: "Please select",

  // Monitor Direction
  bidirectional: "Bidirectional",
  inflow: "Inflow",
  outflow: "Outflow",

  // Monitor Type
  commonMonitor:
    "Common Monitoring (Real-time transaction updates, no push notifications)",
  realtimeMonitor:
    "Real-time Monitoring (Real-time transaction updates and push notifications, select push channel below)",

  // Push Channel
  dingtalk: "DingTalk",
  email: "Email",
  wechat: "WeChat",
  dingtalkHelp: "How to get DingTalk robot signature key and Webhook address?",
  inputDingtalkSecret: "Please enter DingTalk robot signature key",
  inputDingtalkWebhook: "Please enter DingTalk robot Webhook address",
  inputDingtalkPhone:
    "Please enter DingTalk phone number (optional, can @ specific person in DingTalk group)",
  inputEmail: "Please enter email address",

  // WeChat Binding
  bound: "Bound",
  toBind: "To bind, ",
  clickToBind: "Click to scan and bind WeChat",

  // Buttons
  return: "Return",
  confirm: "Confirm",

  // Messages
  maxAmountTip: "Max amount must be ≥ min amount",
  maxValueTip: "Max value must be greater than min value",
  pleaseBindWechat: "Please bind WeChat first",
  pleaseSelectChannel: "Please select a channel",

  // Form Validation
  inputMonitorNameRequired: "Please enter monitor name",
  monitorNameLength: "Length should be 1 to 20 characters",
  selectAmountRange: "Please select amount range",
  minAmountRequired: "Min amount cannot be empty",
  maxAmountRequired: "Max amount cannot be empty",
  selectMonitorDirection: "Please select monitor direction",
  inputRemarkContent: "Please enter remark content",
  selectMonitorType: "Please select monitor type",
  inputCorrectEmail: "Please enter a valid email address",
  inputCorrectPhone: "Please enter a valid phone number",
  inputValidPhone: "Please enter a valid phone number",
  inputDingtalkSecretRequired: "Please enter DingTalk robot signature key",
  inputDingtalkWebhookRequired: "Please enter DingTalk address",
};
